import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import axios from "axios";

const AddGroup = ({ isModalOpen, setIsModalOpen, getGroups }) => {
    const [title, setTitle] = useState("");

    

    const addGroup = async () => {
        const request = await axios({method:'post',
        url:`${process.env.REACT_APP_WEB_API_DEV}api/v1/assessments/add-test-group`,
        data: {name:title},
        headers: {
            authorization: localStorage.getItem("jwtToken"),
            'Content-Type': 'application/json'
        },
        });

        if (request?.data?.meta?.code === 200) {
            getGroups();
        }
        // setTitle(request.data.data);
    }

    const handleOk = () => {
        addGroup();
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Modal title="Enter Details" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <input placeholder='Enter Test Title'
                    style={{
                        width: "100%"
                    }}
                    onChange={(e) => { setTitle(e.target.value) }} />
            </Modal>
        </>
    );
};

export default AddGroup;